import { ErrorPopup } from './components/ErrorPopup';
import { createDynamicWithRetry } from './createDynamicWithRetry';

export const dynamicWithRetry = createDynamicWithRetry({ ErrorFallback: ErrorPopup });
